<template>
  <a-carousel arrows autoplay :autoplaySpeed="5000" :dotsClass="pc?'bannerDotsClass':'bannerDotsClass_m'" :touchMove="false">
    <!--  eslint-disable-next-line vue/no-unused-vars-->
    <div class="hover_red" slot="prevArrow" slot-scope="props" style="top: calc(100% - 24px);width: 55px;z-index: 1" :style="{left: pc ? 'calc(50% - 600px)' : '20px'}">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="55px" height="17px">
        <path fill-rule="evenodd"  fill="rgb(179, 179, 179)" d="M54.669,9.993 L14.151,9.993 C16.103,12.754 17.075,14.555 17.175,17.009 C12.912,14.459 7.630,12.588 -0.015,8.501 C5.693,5.475 11.343,3.090 17.175,-0.011 C16.875,2.657 16.065,4.268 14.090,7.205 L54.669,7.205 L54.669,9.993 Z"/>
      </svg>
    </div>
    <!--  eslint-disable-next-line vue/no-unused-vars-->
    <div class="hover_red" slot="nextArrow" slot-scope="props" style="top: calc(100% - 24px);width: 55px" :style="{left: pc ? 'calc(50% - 525px)' : '95px'}">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="56px" height="17px">
        <path fill-rule="evenodd"  fill="rgb(179, 179, 179)" d="M0.333,7.006 L40.850,7.006 C38.898,4.245 37.926,2.444 37.826,-0.011 C42.089,2.539 47.371,4.410 55.016,8.498 C49.308,11.523 43.658,13.908 37.826,17.009 C38.126,14.342 38.936,12.730 40.911,9.794 L0.333,9.794 L0.333,7.006 Z"/>
      </svg>
    </div>
    <template v-if="pc">
      <div @click="$router.push('/projects')" v-for="(item, index) in $t('home.banner')" :key="index" :style="{backgroundImage: `url(${item.bg})`,backgroundSize: '100% 100%',backgroundRepeat: 'no-repeat'}">
        <img :src="item.text" class="mw1200" width="100%" style="max-height: 498px">
      </div>
    </template>
    <template v-else>
      <div @click="$router.push('/projects')" v-for="(item, index) in $t('home.banner_m')" :key="index">
        <img :src="item.bg" width="100%" />
      </div>
    </template>
  </a-carousel>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['pc'])
  }
}
</script>

<style lang="less">
  .bannerDotsClass {
    position: absolute;
    bottom: 20px;
    left: calc(50% - 415px);
    display: block;
    height: 8px;
    margin: 0;
    padding: 0;
    text-align: center;
    list-style: none;

    li {
      position: relative;
      display: inline-block;
      margin: 0 10px;
      padding: 0;
      text-align: center;
      vertical-align: top;

      button {
        display: block;
        width: 40px;
        height: 4px;
        padding: 0;
        color: transparent;
        font-size: 0;
        background: #b3b3b3;
        border: 0;
        /*border-radius: 1px;*/
        outline: none;
        cursor: pointer;
        -webkit-transition: all 0.5s;
        transition: all 0.5s;
      }

      &.slick-active button {
        background: #7F1F20;
      }
    }
  }

  .bannerDotsClass_m {
    position: absolute;
    bottom: 20px;
    left: 185px;
    display: block;
    height: 8px;
    margin: 0;
    padding: 0;
    text-align: center;
    list-style: none;

    li {
      position: relative;
      display: inline-block;
      margin: 0 10px;
      padding: 0;
      text-align: center;
      vertical-align: top;

      button {
        display: block;
        width: 40px;
        height: 4px;
        padding: 0;
        color: transparent;
        font-size: 0;
        background: #b3b3b3;
        border: 0;
        /*border-radius: 1px;*/
        outline: none;
        cursor: pointer;
        -webkit-transition: all 0.5s;
        transition: all 0.5s;
      }

      &.slick-active button {
        background: #7F1F20;
      }
    }
  }
</style>
